import { Breadcrumbs, Button, Card, CardActions, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { FunctionComponent, useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    centerButton: {
        justifyContent: 'center',
        display: 'flex',
    },

}))

const getYearRange = (retirementYear?: number) => {
    const startYear = 2016;
    const now = new Date().getFullYear();
    const endYear = Math.min(now, retirementYear ?? now);
    const yearList: number[] = [];
    for (let i = startYear; i <= endYear; i++) {
        yearList.push(i);
    }
    return yearList.reverse();
}

type PymentForm = {
    year: number,
    month: number,
    file: any,
    fileName?: string,
}

type EmpPayslipPageProps = {
}

type PensionerApiData = {
    name: string,
    spouseName: string,
    pensionerAddr: string,
    dobSpouse: string,
    dtRet: string,
    categoryPensioner: string,
    lastPenMonth: string,
    pensionerType: string,
    aadharNo: string,
    panId: string,
    contactNo: string,
    emailId: string,
    bankAccNum: string,
}

type PensionerProfileState = {
    loading: boolean,
    error: string,
    profile: Array<PensionerApiData>
}

export const EmpPayslipPage: FunctionComponent<EmpPayslipPageProps> = () => {
    const classes = useStyles()
    const store = useStore()
    const [profileData, setProfile] = useState<PensionerProfileState>({ loading: true, error: '', profile: [] });

    useEffect(() => {
        fetchProfile()
    }, []);


    const fetchProfile = async () => {
        axios.get<ApiResponse<{ profile: PensionerApiData[] }>>(`api/pensioner/profile-details`, {
            headers: {
                'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}`
            }
        })
            .then(
                ({ data: resp }) => {
                    if (resp.status === "success") {
                        const profile: PensionerApiData[] = resp.data.profile;
                        setProfile({ loading: false, error: '', profile: profile })
                    } else {
                        setProfile({ loading: false, error: resp.message, profile: [] })
                    }
                },
                () => { setProfile({ loading: false, error: "Network Error", profile: [] }) }
            )
    }

    // Optional: block family pensioner

    const retirementDate = profileData?.profile[0]?.dtRet;
    const pensionerTypeRaw = profileData?.profile[0]?.pensionerType?.toLowerCase();
    const isSelf = pensionerTypeRaw === "self";
    let retirementYear = 0;
    try {
        if (retirementDate) {
            retirementYear = new Date(retirementDate).getFullYear();
        }
    } catch (e) {
        retirementYear = 0;
    }

    const yearRange = profileData.loading ? [] : getYearRange(retirementYear);

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    initialValues={{
                        year: 2016,
                        month: 1,
                        file: null,
                    }}
                    validate={(values) => {
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                        setSubmitting(true);
                        let payslipMonth, payslipYear;
                        if (values.month >= 3) {
                            payslipMonth = values.month - 2;
                            payslipYear = values.year;
                        } else {
                            payslipMonth = values.month - 2 + 12;
                            payslipYear = values.year - 1;
                        }
                        setFieldValue('fileName', `monthly-payslip-${payslipYear}-${payslipMonth}.pdf`)
                        setFieldValue('file', {
                            url: `${process.env.REACT_APP_API_ROOT}api/pensioner/emp-monthly-payslip/${payslipYear}/${payslipMonth}`,
                            // setFieldValue('fileName', `monthly-payslip-${values.year}-${values.month}.pdf`)
                            // setFieldValue('file', {
                            //     url: `${process.env.REACT_APP_API_ROOT}api/pensioner/emp-monthly-payslip/${values.year}/${values.month}`,
                            httpHeaders: { 'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}` },
                        })
                    }}
                >
                    {
                        ({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<PymentForm>) =>
                            <Form>
                                <Grid
                                    item
                                    container
                                    spacing={3}
                                    direction="column"
                                    justify="space-around"
                                    alignItems="stretch"
                                >
                                    <Grid item>
                                        <Card className={classes.controlPaper}>
                                            <CardContent>
                                                <Grid container spacing={3} direction="column" justify="space-around"
                                                    alignItems="stretch">
                                                    <Grid item>
                                                        <Breadcrumbs>
                                                            <Link to="/" className={classes.link}>
                                                                <Typography gutterBottom variant="h5" component="h2">
                                                                    <HomeIcon className={classes.icon} />Home</Typography>
                                                            </Link>
                                                            <Typography gutterBottom variant="h5" component="h2">Monthly Payslip (কর্মকালীন মাসিক বেতন বিবরণী)</Typography>
                                                        </Breadcrumbs>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>

                                        </Card>
                                    </Grid>
                                    <Grid item>


                                        {/*  Error fetching profile */}
                                        {!profileData.loading && profileData.error && (
                                            <Alert severity="error">
                                                <AlertTitle>Error</AlertTitle>
                                                {profileData.error}
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={fetchProfile}
                                                    style={{ marginTop: '1rem' }}
                                                >
                                                    Retry
                                                </Button>
                                            </Alert>
                                        )}

                                        {/* Not self (family pensioner) */}
                                        {!profileData.loading && !profileData.error && !isSelf && (
                                            <><Alert severity="error" style={{ textAlign: "justify" }}>
                                                <AlertTitle>Error</AlertTitle>
                                                This facility is not available for family pensioners. <br />
                                                <b>(পারিবারিক পেনশনভোগীদের জন্য এই সুবিধাটি উপলব্ধ নয়।)</b>
                                            </Alert>
                                            <br/>
                                                <Grid item className={classes.centerButton}>
                                                    <Link to="/" className={classes.link}>
                                                        <Button variant='contained' color='primary' size='large'>
                                                            Back (পিছনে)
                                                        </Button>
                                                    </Link>
                                                </Grid></>
                                        )}

                                        {/*  Retired before 2016 */}
                                        {!profileData.loading && !profileData.error && isSelf && retirementYear < 2016 && (
                                            <><Alert severity="warning" style={{ textAlign: "justify" }}>
                                                <AlertTitle>Warning</AlertTitle>
                                                Payslip facility is available only for pensioners retired in or after 2016. <br />
                                                <b>(বেতন বিবরণী সুবিধা শুধুমাত্র ২০১৬ সালে বা তার পরে অবসরপ্রাপ্ত পেনশনভোগীদের জন্য উপলব্ধ।)</b>
                                            </Alert>
                                            <br/>
                                                <Grid item className={classes.centerButton}>
                                                    <Link to="/" className={classes.link}>
                                                        <Button variant='contained' color='primary' size='large'>
                                                            Back (পিছনে)
                                                        </Button>
                                                    </Link>
                                                </Grid></>

                                        )}

                                    </Grid>
                                    {
                                        !profileData.loading && !profileData.error && isSelf && retirementYear >= 2016 &&
                                        <>
                                            <Grid item>
                                                <Card elevation={3}>
                                                    <CardContent>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12}>
                                                                <FormControl variant="filled" fullWidth disabled={isSubmitting}>
                                                                    <InputLabel id="demo-simple-select-filled-label">Year (বছর)</InputLabel>
                                                                    <Select
                                                                        labelId="demo-simple-select-filled-label"
                                                                        id="demo-simple-select-filled"
                                                                        name="year"
                                                                        value={values.year}
                                                                        onChange={handleChange}
                                                                    >
                                                                        {
                                                                            yearRange.map((y) => <MenuItem value={y}>{y}</MenuItem>)
                                                                        }
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <FormControl variant="filled" fullWidth disabled={isSubmitting}>
                                                                    <InputLabel id="demo-simple-select-filled-label">Month (মাস)</InputLabel>
                                                                    <Select
                                                                        labelId="demo-simple-select-filled-label"
                                                                        id="demo-simple-select-filled"
                                                                        name="month"
                                                                        value={values.month}
                                                                        onChange={handleChange}
                                                                    >
                                                                        <MenuItem value={1}>January (জানুয়ারী)</MenuItem>
                                                                        <MenuItem value={2}>February (ফেব্রুয়ারী)</MenuItem>
                                                                        <MenuItem value={3}>March (মার্চ)</MenuItem>
                                                                        <MenuItem value={4}>April (এপ্রিল)</MenuItem>
                                                                        <MenuItem value={5}>May (মে)</MenuItem>
                                                                        <MenuItem value={6}>June (জুন)</MenuItem>
                                                                        <MenuItem value={7}>July (জুলাই)</MenuItem>
                                                                        <MenuItem value={8}>August (আগস্ট)</MenuItem>
                                                                        <MenuItem value={9}>September (সেপ্টেম্বর)</MenuItem>
                                                                        <MenuItem value={10}>October (অক্টোবর)</MenuItem>
                                                                        <MenuItem value={11}>November (নভেম্বর)</MenuItem>
                                                                        <MenuItem value={12}>December (ডিসেম্বর)</MenuItem>

                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>

                                                            <CardActions>
                                                                <Button type="reset" size="large" color="primary" variant="contained" disabled={isSubmitting}>
                                                                    Reset (রিসেট)
                                                                </Button>
                                                                <LoadingButton type="submit" size="large" color="primary" variant="contained" loading={isSubmitting}>
                                                                    Load Statement (লোড স্টেটমেন্ট)
                                                                </LoadingButton>

                                                                <Link to="/" className={classes.link}>
                                                                    <Button variant='contained' color='primary' size='large'>
                                                                        Back (পিছনে)
                                                                    </Button>
                                                                </Link>

                                                            </CardActions>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            {
                                                !!values.file && !!values.fileName &&
                                                < Grid item xs={12}>
                                                    <Card elevation={3}>
                                                        <CardContent>
                                                            <Grid container spacing={3}>
                                                                <PdfViewer
                                                                    downloadFileName={values.fileName}
                                                                    file={values.file}
                                                                    onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                                    onDocumentLoadError={() => { setSubmitting(false) }}
                                                                    error={
                                                                        <>
                                                                            <Typography
                                                                                variant="h6"
                                                                                component="h6"
                                                                                style={{ textAlign: "center" }}
                                                                                color="secondary">
                                                                                Salary statement is not available for the chosen period. Please contact the pension cell. <br />
                                                                                <b>(নির্বাচিত সময়ের জন্য বেতন বিবৃতি উপলব্ধ নেই। দয়া করে পেনশন সেলের সাথে যোগাযোগ করুন।)</b>
                                                                            </Typography>
                                                                        </>
                                                                    }
                                                                />
                                                            </Grid>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>


                                            }

                                        </>
                                    }
                                </Grid>

                            </Form>

                    }
                </Formik>

            </Grid>
        </AppShell >
    )
}